export const ru = {
    'empty-words': 'Нет уточняющих слов',
    'empty-words-content': 'Уточнения не найдены. Чтобы уточнить фразу заполните минус-слова вручную.',
    'error-words': 'Не удалось загрузить уточнения',
    'refine-note': 'Чтобы уточнить ключевую фразу, отметьте минус-слова.',
    'show-more': 'Показать ещё',
    'shows-text': 'Прогноз показов в месяц — {showsCount}',
    'word-shows': {
        one: '{count} показ',
        some: '{count} показа',
        many: '{count} показов',
        none: '{count} показов'
    }
};
